import React, { Fragment, Component } from 'react';
import { Helmet } from 'react-helmet';
import { withRouter } from 'react-router-dom';
import arrowDown from '../../images/arrow-down-black.svg';
// import './generalFaq.css';
import './faq.css';
import tempSchedule from '../../images/tempPaymentSchedule.png';

import Header from '../NewProfile/Header';
import SideBarContent from '../SideBar/SideBarContent';

class PaymentFaq extends Component {
  render() {
    const { status, email, history } = this.props;
    const faq_content = [
      {
        title: 'Why is the payment processing delayed?',
        text: (
          <p>
            Our automated payment system with our Canadian financial
            partner, is undergoing a routine annual review. This review
            ensures the protection of your funds against any misuse, hacks
            or fraudulent activity. As a result, the funds are being
            processed 4-5 business days late, thereby causing a delay. This
            is affecting all our drivers in Canada.
          </p>
        )
      },
      {
        title: 'When can I expect my payout to be transferred?',
        text: (
          <p>
            Your weekly payout will be processed to you every <b>second</b>{' '}
            Tuesday after your booking week finishes. (A booking week is
            from Monday - Sunday).
          </p>
        )
      },
      {
        title: 'When will the regular payment cycle resume?',
        text: (
          <p>
            This Audit is temporary and will be resolved within a few
            weeks. Once finished , your weekly payout cycle (every Tuesday)
            will resume immediately.
          </p>
        )
      },
      {
        title: 'Who can I talk to about my payment?',
        text: (
          <p>
            If you have any questions or concerns, please call us at
            1-833-692-8898 or email us at drivers@autzu.com
          </p>
        )
      }
    ];
    return (
      <Fragment>
        <Helmet>
          <title>Payment FAQ | Autzu</title>
          <meta
            name="description"
            content="Get all the answers to your frequently asked questions about our payment system upgrades."
          />
        </Helmet>
        <section className="container">
          <div className="newFaq">
            <Header
              persistentTitle
              title="Payment FAQ"
              back
              onClick={() => {
                history.goBack();
              }}
            />
            {/* <div className="general-faq-header">
                <h2 className="general-faq-header--size">Payment FAQ</h2>
              </div> */}
            <div className="newFaq__body container">
              <div className="newFaq__container">
                <div className="newFaq__sidebar">
                  <SideBarContent status={status} signedIn={email} />
                </div>
                <div className="newFaq__content--container">
                  <div className="payment-faq__blurb--">
                    <div className="">
                      <div id="generalAccordion1">
                        <div
                          id="general1"
                          className="panel-collapse collapse in">
                          <div
                            className="panel-body"
                            style={{ padding: '0px' }}>
                            <div
                              className="panel-group"
                              id="generalAccordion2">
                              {faq_content.map((content, index) => (
                                <div
                                  key={`payment-faq-item${index}`}
                                  className="mini-faq__panel">
                                  <div
                                    className="mini-faq__heading collapsed"
                                    data-toggle="collapse"
                                    href={`#paymentFaq${index + 1}`}>
                                    <h4 className="mini-faq__panel--title">
                                      {content.title}{' '}
                                    </h4>
                                    {/* <img className="mini-faq__arrow" src={arrowDown} alt="arrow" /> */}
                                  </div>
                                  <div
                                    id={`paymentFaq${index + 1}`}
                                    className="panel-collapse">
                                    <div className="mini-faq__panel--body">
                                      {content.text}
                                      {content.image ? (
                                        <img
                                          className="banner__schedule--image"
                                          alt="schedule"
                                          src={tempSchedule}
                                          style={{
                                            display: 'block',
                                            width: '90%',
                                            margin: 'auto'
                                          }}
                                        />
                                      ) : null}
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Fragment>
    );
  }
}
export default withRouter(PaymentFaq);



// WEBPACK FOOTER //
// ./src/components/Static/PaymentFaq.js